<template>
  <van-popup v-model="isVisible"
    class="custom-pop"
    :close-on-click-overlay="closeOnClickOverlay"
    v-bind="$attrs"
    v-on="$listeners">
    <div class="pop">
      <div class="pop-header">
        <span class="pop-header-left">{{title}}</span>
        <van-icon name="cross" @click="onClose" />
      </div>
      <slot name="contentUp"></slot>
      <div class="pop-content">
        <slot></slot>
      </div>
      <div class="pop-footer" v-if="showFooter">
        <slot name="footer">
          <van-button class="btn btn-black" size="small" @click="onCancel">{{cancelText}}</van-button>
          <van-button class="btn btn-orange" size="small" @click="onConfirm">{{confirmText}}</van-button>
        </slot>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'QDialog',
  inheritAttrs: false,
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    title: String,
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    // 关闭时是否触发取消事件
    closeWithCancel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onConfirm() {
      this.$emit('confirm')
    },
    onClose() {
      this.$emit('close');
      if (this.closeWithCancel) {
        this.$emit('cancel');
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.custom-pop
  box-sizing border-box
  width 95%
  border-radius 3px
.pop
  font-size 14px
  &-header
    height 26px
    display flex
    justify-content space-between
    align-items center
    padding 4px 8px
    color #ffffff
    background-color #00B78E
    &-left
      flex 1
  &-content
    min-height 40px
    padding 0 15px
  &-footer
    display flex
    justify-content space-around
    align-items center
    width 100%
    padding 16px 0
    .btn
      min-width 112px
      border-radius 3px
</style>